@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;
@use "./tokensV2" as tokens;

.container {
  display: flex;
  flex-direction: column;

  position: relative;
  margin-top: 15px;
  margin-bottom: 8px;
}

.apptContainer {
  display: flex;
  flex-direction: column;

  position: relative;
  margin-top: 4px;
  margin-bottom: 0;
}

.caimContainer {
  display: flex;
  flex-direction: column;

  position: relative;
  margin-top: 4px;
  margin-bottom: 0;
  padding-bottom: 16px;
}

.tooltip {
  margin-top: 20px;

  @include breakpoints.desktop {
    margin-top: 0;
    width: 300px;

    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-20%);
  }
}

.tooltipAfterError {
  margin-top: 0;
  order: 100; // move to the end of the flex container
}

.input {
  background-color: var(--gray-04);
  width: 100%;
  padding: 9px;
  border-radius: tokens.$border-radius;
  appearance: none;
  height: tokens.$height;
  border: 1px solid var(--blue-01-at-30);
  font-family: typography.$font-mont;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  letter-spacing: 0%;
}

.inputCustom {
  background-color: var(--gray-04);
  width: 100%;
  padding: 9px;
  border-radius: tokens.$border-radius;
  appearance: none;
  height: tokens.$height;
  border: 1px solid var(--blue-01-at-30);
}

.input::placeholder {
  color: var(--black-at-75);
  opacity: 1;
}

.input:valid {
  border-color: var(--blue-01-at-30);
  font-family: typography.$font-mont;
}

.input:focus {
  outline: none;
  border-color: var(--blue-01);
  font-family: typography.$font-mont;
}

.input:read-only {
  background-color: var(--blue-03);
  border: 1px dashed var(--blue-01-at-30);
  caret-color: transparent;
}

.input:read-only:focus {
  border: 1px dashed var(--blue-01-at-30);
}

.label {
  color: var(--brand-indigo);
  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 12px;
  line-height: 110%;
  letter-spacing: 0%;
  margin-bottom: 5px;
}

.errorMessage {
  @include tokens.error-message;
  font-family: typography.$font-mont;
}

.errorMessageCIAM{
  @include tokens.error-message;
  text-align: left !important;
}

.inputContainer {
  position: relative;
}

.errorIcon {
  @include tokens.error-icon;
}

.error,
.error:valid {
  @include tokens.error-box;
}

.ciam_error {
  border: 1px solid var(--Additional-Color---additional-interface-color-300-magenta, var(--magenta)) !important;
}